// Client-side code formatting via Prettier's browser-safe standalone build.
// Each language's plugin(s) are only downloaded the first time that
// language is actually formatted (dynamic import), same lazy-loading
// pattern as defineTheme.js for Monaco themes.
const PARSER_BY_LANGUAGE = {
  javascript: "babel",
  typescript: "typescript",
  html: "html",
  css: "css",
  // SVG is XML, but Prettier has no dedicated XML parser bundled — its
  // HTML printer understands embedded SVG well enough to be useful here.
  svg: "html",
};

const PLUGIN_LOADERS = {
  babel: () =>
    Promise.all([import("prettier/plugins/babel"), import("prettier/plugins/estree")]),
  typescript: () =>
    Promise.all([
      import("prettier/plugins/typescript"),
      import("prettier/plugins/estree"),
    ]),
  html: () => Promise.all([import("prettier/plugins/html")]),
  css: () => Promise.all([import("prettier/plugins/postcss")]),
};

export function isFormattable(language) {
  return Object.prototype.hasOwnProperty.call(PARSER_BY_LANGUAGE, language);
}

export async function formatCode(code, language) {
  const parser = PARSER_BY_LANGUAGE[language];
  if (!parser) {
    throw new Error(`Formatting isn't supported for ${language}.`);
  }

  const [{ format }, plugins] = await Promise.all([
    import("prettier/standalone"),
    PLUGIN_LOADERS[parser](),
  ]);

  return format(code, { parser, plugins });
}
